module.exports = __webpack_public_path__ + "static/media/intro.8e60b4fc.mp3";